<div class="admin-panel">
  <div class="admin-layout">
    <aside class="admin-side-panel mat-elevation-z1">
      <div class="panel-title">Sections</div>
      <button
        *ngFor="let item of menuItems"
        type="button"
        class="menu-item"
        [class.active]="selectedSection === item.key"
        (click)="selectSection(item.key)"
      >
        <span>{{ item.label }}</span>
      </button>
    </aside>

    <section class="admin-content">
      <app-manage-demos *ngIf="selectedSection === 'demos'" [token]="token"></app-manage-demos>

      <app-manage-topic-areas *ngIf="selectedSection === 'topic-areas'" [token]="token"></app-manage-topic-areas>

      <app-pending-files *ngIf="selectedSection === 'pending-files'" [token]="token"></app-pending-files>

      <app-manage-ads *ngIf="selectedSection === 'ads'" [token]="token"></app-manage-ads>

      <app-manage-alerts *ngIf="selectedSection === 'alerts'" [token]="token"></app-manage-alerts>

      <app-manage-users *ngIf="selectedSection === 'users'" [token]="token"></app-manage-users>

      <app-manage-environments *ngIf="selectedSection === 'environments'" [token]="token"></app-manage-environments>

      <app-special-events *ngIf="selectedSection === 'special-events'" [token]="token"></app-special-events>

      </section>
  </div>
</div>
